var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check_container"},[_c('div',{staticClass:"check_content"},[_c('div',{staticClass:"check_point",class:{ select: _vm.select }}),_vm._v(" "),_c('div',{staticClass:"activity_type"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }